import ActiveIconSvg from "./active-icon.svg";
import AuditLogIconSvg from "./audit-log-icon.svg";
import BackIconSvg from "./back-icon.svg";
import BlockedIconSvg from "./blocked-icon.svg";
import CardDotIconSvgUrl from "./card-dot-icon.svg?url";
import CrossIconSvg from "./cross-icon.svg";
import DeleteIconSvg from "./delete-icon.svg";
import DeliveredSvg from "./delivered.svg";
import DistributorIconSvg from "./distributor-icon.svg";
import DocumentsSvg from "./documents.svg";
import EditIconSvg from "./edit-icon.svg";
import FilterIconSvg from "./filter-icon.svg";
import InfoIconSvg from "./info-icon.svg";
import LimitWarningIconSvg from "./limit-warning-icon.svg";
import LoaderIconSvgUrl from "./loader-icon.svg?url";
import MenuIconSvg from "./menu-icon.svg";
import MovedSvg from "./moved.svg";
import RawDataLogIconSvg from "./raw-data-log-icon.svg";
import ReadyToInstallSvg from "./ready to install.svg";
import RecivedSvg from "./recived.svg";
import RefuelingIconSvg from "./refueling-icon.svg";
import RefuelingIconSvgUrl from "./refueling-icon.svg?url";
import ReturnedSvg from "./returned.svg";
import RoutesIconSvg from "./routes-icon.svg";
import SearchIconSvg from "./search-icon.svg";
import SidebarCustomersIconSvg from "./sidebar-customers-icon.svg";
import SidebarChevronIconSvg from "./sidebar-chevron-icon.svg";
import SidebarCollapseIconSvg from "./sidebar-collapse-icon.svg";
import SidebarDashboardIconSvg from "./sidebar-dashboard-icon.svg";
import SidebarDeviceIconSvg from "./sidebar-device-icon.svg";
import SidebarSettingsIconSvg from "./sidebar-settings-icon.svg";
import SidebarUserManagementIconSvg from "./sidebar-user-management-icon.svg";
import SidebarWarehouseIconSvg from "./sidebar-warehouse-icon.svg";
import TachographIconSvg from "./tachograph-icon.svg";
import TpmsIconSvg from "./tpms-icon.svg";
import UnitIconSvgUrl from "./unit-icon.svg?url";
import UserEnabledStatusIconSvgUrl from "./user-enabled-status.svg?url";
import VehickeUnitIconSvgUrl from "./vehicke-unit-icon.svg?url";
import WarehouseAreaIconSvgUrl from "./warehouse-area-icon.svg?url";
import WarehouseIconSvgUrl from "./warehouse-icon.svg?url";
import WarehouseLaneIconSvgUrl from "./warehouse-lane-icon.svg?url";
import ArrowDownIconSvg from "./arrow-down-icon.svg";
import ArrowDownIconSvgUrl from "./arrow-down-icon.svg?url";
import MappingFilterIconSvgUrl from "./mapping-filter-icon.svg?url";
import MappingRightArrowIconSvgUrl from "./mapping-right-arrow-icon.svg?url";
import MappingRemoveFilterIconSvgUrl from "./mapping-remove-filter-icon.svg?url";
import MappingDrawerCrossIconSvgUrl from "./mapping-drawer-cross-icon.svg?url";
import TachoCardTickIconSvg from "./tacho-card-status-tick-icon.svg";
import TachoCardCrossIconSvg from "./tacho-card-status-cross-icon.svg";

export const ActiveIcon = ActiveIconSvg;
export const AUDIT_LOG_ICON = AuditLogIconSvg;
export const BACK_ICON = BackIconSvg;
export const BlockedIcon = BlockedIconSvg;
export const CARD_DOT_ICON = CardDotIconSvgUrl;
export const CROSS_ICON = CrossIconSvg;
export const CrossIcon = CrossIconSvg;
export const DELETE_ICON = DeleteIconSvg;
export const DeleteIcon = DeleteIconSvg;
export const DELIVERED_ICON = DeliveredSvg;
export const DISTRIBUTOR_ICON = DistributorIconSvg;
export const DETAILS_ICON = DocumentsSvg;
export const EDIT_ICON = EditIconSvg;
export const EditIcon = EditIconSvg;
export const FILTER_ICON = FilterIconSvg;
export const FilterIcon = FilterIconSvg;
export const INFO_ICON = InfoIconSvg;
export const LIMIT_WARNING_ICON = LimitWarningIconSvg;
export const LOADER_ICON = LoaderIconSvgUrl;
export const MenuIcon = MenuIconSvg;
export const MOVED_ICON = MovedSvg;
export const RAW_DATA_LOG_ICON = RawDataLogIconSvg;
export const READY_TO_INSTALL_ICON = ReadyToInstallSvg;
export const RECEIVED_ICON = RecivedSvg;
export const REFUELING_ICON = RefuelingIconSvgUrl;
export const REFUELING_ICON_COMPONENT = RefuelingIconSvg;
export const RETURNED_ICON = ReturnedSvg;
export const ROUTES_ICON = RoutesIconSvg;
export const SEARCH_ICON = SearchIconSvg;
export const SearchIcon = SearchIconSvg;
export const SidebarChevronIcon = SidebarChevronIconSvg;
export const SidebarCollapseIcon = SidebarCollapseIconSvg;
export const SidebarCustomersIcon = SidebarCustomersIconSvg;
export const SidebarDashboardIcon = SidebarDashboardIconSvg;
export const SidebarDeviceIcon = SidebarDeviceIconSvg;
export const SidebarSettingsIcon = SidebarSettingsIconSvg;
export const SidebarUserManagementIcon = SidebarUserManagementIconSvg;
export const SidebarWarehouseIcon = SidebarWarehouseIconSvg;
export const TACHOGRAPH_ICON = TachographIconSvg;
export const TPMS_ICON = TpmsIconSvg;
export const UNIT_ICON = UnitIconSvgUrl;
export const USER_ENABLED_STATUS_ICON = UserEnabledStatusIconSvgUrl;
export const VEHICLE_UNIT_ICON = VehickeUnitIconSvgUrl;
export const WAREHOUSE_AREA_ICON = WarehouseAreaIconSvgUrl;
export const WAREHOUSE_ICON = WarehouseIconSvgUrl;
export const WAREHOUSE_LANE_ICON = WarehouseLaneIconSvgUrl;
export const ArrowDownIcon = ArrowDownIconSvg;
export const ARROW_DOWN_ICON = ArrowDownIconSvgUrl;
export const MAPPING_FILTER_ICON = MappingFilterIconSvgUrl;
export const MAPPING_RIGHT_ARROW_ICON = MappingRightArrowIconSvgUrl;
export const MAPPING_REMOVE_FILTER_ICON = MappingRemoveFilterIconSvgUrl;
export const MAPPING_DRAWER_CROSS_ICON = MappingDrawerCrossIconSvgUrl;
export const TACHO_CARD_TICK_ICON = TachoCardTickIconSvg;
export const TACHO_CARD_CROSS_ICON = TachoCardCrossIconSvg;
